import React, { Fragment } from 'react'
import { FormattedMessage } from 'react-intl'
import { Text, Button, IconXOctagon, csx } from '@vtex/admin-ui'

interface PaymentAppErrorProps {
  onRetry: () => void
  onNewPayment: () => void
}

const PaymentAppError = ({
  onRetry: handleRetry,
  onNewPayment: handleNewPayment,
}: PaymentAppErrorProps) => {
  return (
    <Fragment>
      <div
        className={csx({
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          flexGrow: 1,
        })}
      >
        <IconXOctagon
          weight="fill"
          className={csx({
            width: '45.5px',
            height: '45.5px',
            color: 'rgba(204, 61, 61, 1)',
          })}
        />
        <Text
          variant="pageTitle"
          className={csx({
            textAlign: 'center',
            fontWeight: 'bold',
            marginTop: '46px',
            marginX: '40px',
          })}
        >
          <FormattedMessage id="paymentApp.modal.error.title" />
        </Text>
        <Text
          className={csx({
            textAlign: 'center',
            marginTop: '24px',
            marginX: '28px',
          })}
        >
          <FormattedMessage id="paymentApp.modal.error.description" />
        </Text>
      </div>
      <div
        className={csx({
          display: 'flex',
          flexDirection: 'column',
          margin: '16px',
        })}
      >
        <Button className={csx({ height: '48px' })} onClick={handleRetry}>
          <FormattedMessage id="paymentApp.modal.error.button.primary" />
        </Button>
        <Button
          className={csx({ height: '48px', marginTop: '24px' })}
          variant="tertiary"
          onClick={handleNewPayment}
        >
          <FormattedMessage id="paymentApp.modal.error.button.secondary" />
        </Button>
      </div>
    </Fragment>
  )
}

export default PaymentAppError
